
/**
 * Конвертирует длительность в секундах в читаемый формат.
 * Меньше часа — М:СС (например, 3911 сек → "65:11"... нет, ниже часа даём М:СС,
 * от часа — Ч:ММ:СС.
 */
export function formatDuration(totalSec) {
  if (totalSec == null || isNaN(totalSec)) return '—';

  const hours = Math.floor(totalSec / 3600);
  const minutes = Math.floor((totalSec % 3600) / 60);
  const seconds = Math.round(totalSec % 60);

  if (hours > 0) {
    return `${hours}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  }
  return `${minutes}:${String(seconds).padStart(2, '0')}`;
}
